export enum StoreKeys {
  Company = "Company",
  Language = "Language",
  Dates = "Dates",
  Categories = "Categories",
  Levels = "Levels",
}
